import Survey from './Survey'

export default Survey